/* DIFAVO / core behaviour. Scroll reveal + sticky buy bar. Loaded once from layout/theme.liquid. */
(function () {
  if (window.__dvInit) return; window.__dvInit = 1;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function reveal() {
    var els = document.querySelectorAll('[data-dv-reveal]:not(.dv-in)');
    if (!('IntersectionObserver' in window) || reduce) {
      Array.prototype.forEach.call(els, function (e) { e.classList.add('dv-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (x) {
        if (x.isIntersecting) { x.target.classList.add('dv-in'); io.unobserve(x.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    Array.prototype.forEach.call(els, function (e) { io.observe(e); });
  }
  function stickyBuy() {
    var bar = document.querySelector('.dv-stickybuy');
    if (!bar) return;
    var onScroll = function () {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      var end = document.body.scrollHeight - window.innerHeight - 900;
      bar.classList.toggle('dv-in', y > window.innerHeight * 0.9 && y < end);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
  function boot() { reveal(); stickyBuy(); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
